import { gql } from "@apollo/client";

const LOGIN = gql`
 mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password) {
    accessToken
    refreshToken
    status
    user {
      ... on InternalUser {
        _id
        roles
        type
        meta {
          testData
        }
      }
      ... on DonorUser {
        _id
        roles
        type
        meta {
          testData
        }
      }
      ... on FirmUser {
        _id
        roles
        type
        meta {
          testData
        }
      }
      ... on EntityUser {
        _id
        roles
        type
        meta {
          testData
        }
      }
    }
  }
}
`;

const VALIDATE_EMAIL = gql`
 mutation ValidateEmail($email: String!, $emailToken: String!, $tokenType: String!) {
  validateEmail(email: $email, emailToken: $emailToken, tokenType: $tokenType) {
    accessToken
    refreshToken
    user {
      ... on InternalUser {
        _id
        emailVerified
      }
      ... on DonorUser {
        _id
        emailVerified
      }
      ... on FirmUser {
        _id
        emailVerified
      }
      ... on EntityUser {
        _id
        emailVerified
      }
    }
  }
}
`;

const EXCHANGE_ACCESS_TOKEN = gql`
mutation ExchangeAccessToken($refreshToken: ID!) {
  exchangeAccessToken(refreshToken: $refreshToken) {
    accessToken
  }
}
`;


export {
  LOGIN,
  VALIDATE_EMAIL,
  EXCHANGE_ACCESS_TOKEN
}